module.exports = __webpack_public_path__ + "img/webclip.f4ba3ea6.png";